'use server';

import { SessionService } from '@/contexts/authentication';
import { guardActionResult } from '@/shared/entityIds';
import type { Illustration } from '@/contexts/illustrations/types';

export async function getIllustrationsByStory(storyId: string): Promise<Illustration[]> {
  const familyId = await SessionService.getFamilyId();
  if (!familyId) return [];

  const { IllustrationService } = await import('@/contexts/illustrations/services/BookService');
  const { getIllustrationRepository } = await import('@/contexts/illustrations/repositories');
  const { getStoryRepository } = await import('@/contexts/stories/repositories');
  const { getCharacterRepository } = await import('@/contexts/characters/repositories');

  const illustrationService = new IllustrationService(getIllustrationRepository(), getStoryRepository(), getCharacterRepository());
  // books, pages and ref cards are rendered from this as is (entity-id guard, registry plan §4.2)
  return guardActionResult(await illustrationService.getIllustrationsByStory(familyId, storyId));
}
